import axios from '@/api/axios';

export async function addFile(formData) {
  try {
    await axios.post('/audio/uploads', formData);
  } catch (error) {
    console.log(error);
  }
}

export async function deleteFile() {
  try {
    await axios.post('/audio/delete');
  } catch (error) {
    console.log(error);
  }
}
